/**
 * §A · El marco de pestañas de una sección del back office.
 *
 * ## Uno genérico, y no cinco iguales
 *
 * El panel tiene un marco por sección —`MarcoDeCobros`, `MarcoDelClub`,
 * `MarcoDeInformes`…— y ahí está bien: cada uno lleva su guardián de rol, su
 * redirección y su propia explicación de por qué esa pestaña va primera.
 *
 * Aquí no hay ninguna de las tres cosas. `platform: { audit }` no distingue grados de
 * acceso, así que ninguna pestaña se esconde a nadie, y cinco ficheros idénticos
 * salvo el array serían cinco sitios donde arreglar el mismo fallo. El porqué del
 * orden de cada una vive en `secciones.ts`, junto a su array, que es donde se lee.
 *
 * El nombre de la sección entra para la etiqueta accesible: «Pantallas de Dinero» le
 * dice a quien navega con teclado dónde está, y un `aria-label` repetido en cinco
 * navegaciones de la misma página no distingue nada.
 */
import { Link, Outlet, useRouterState } from '@tanstack/react-router';

export function MarcoDeSeccion({
  seccion,
  etiqueta,
  vistas,
}: {
  seccion: string;
  etiqueta: string;
  vistas: readonly { id: string; etiqueta: string }[];
}) {
  const camino = useRouterState({ select: (s) => s.location.pathname });

  return (
    <>
      <nav className="pestañas" aria-label={`Pantallas de ${etiqueta}`}>
        {vistas.map((v) => {
          const destino = `/admin/${seccion}/${v.id}`;
          return (
            <Link
              key={v.id}
              to={destino}
              className={
                /*
                 * `startsWith` y no igualdad: estando en la ficha de una persona
                 * —`/admin/soporte/personas/01a0…`— la pestaña «Personas» tiene que
                 * seguir marcada. Con igualdad, abrir una ficha apaga la pestaña y
                 * nadie sabe dónde está.
                 */
                camino.startsWith(destino) ? 'pestaña-activa' : 'btn-plano'
              }
            >
              {v.etiqueta}
            </Link>
          );
        })}
      </nav>

      <Outlet />
    </>
  );
}
